import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { CdnIcon } from '@shared/ui';

import { BaseButton, ModalX } from '../../../../../BaseComponents';

import { useTheme } from '../../../../../theme';
import { Sorting } from '../../../../enums';

import { useToggleable } from '../../../../../hooks';
import { useIsTablet } from '../../../../../utils';

import { useSortings } from './hooks';
import { Filter, List, ListOption } from '@shared/ui';

export interface Props {
	currentSort: Sorting;
	onSelect: (sorting: Sorting) => void;
}

const Sortings: React.FC<Props> = ({ currentSort, onSelect }) => {
	const { t } = useTranslation('Results');
	const { Sortings: css } = useTheme('Results');

	const { isOpen, open, close } = useToggleable(false);

	const isTablet = useIsTablet();

	const { sortingOptions, currentSorting } = useSortings(currentSort);

	const renderSorting = (
		<Filter
			variant="dropdown"
			options={sortingOptions}
			value={currentSorting}
			onChange={option => onSelect(+option.value)}
			name={`${t('Sort by')}: `}
		/>
	);

	const onModalSelect = (option: ListOption) => {
		onSelect(+option.value);
		setTimeout(close, 500);
	};

	if (isTablet) {
		return (
			<>
				<BaseButton variant="smallBrand" data-test-id="sortings-open" onClick={open}>
					<CdnIcon icon="Action/Filter" />
				</BaseButton>

				<ModalX
					isOpen={isOpen}
					onClose={close}
					classes={{
						closeButton: css.modal__closeButton
					}}
				>
					<List
						className={css.sorting__list}
						dataTestId="sortings"
						options={sortingOptions}
						value={currentSorting}
						onChange={onModalSelect}
					/>
				</ModalX>
			</>
		);
	}

	return (
		<div className={css.sorting__wrapper} data-test-id="sortings">
			{renderSorting}
		</div>
	);
};

export default Sortings;
